import { render, staticRenderFns } from "./FornecedorWFDetalheGeral.vue?vue&type=template&id=70098f5e&"
import script from "./FornecedorWFDetalheGeral.vue?vue&type=script&lang=js&"
export * from "./FornecedorWFDetalheGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports